import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PUBLIC_URL } from './config';

// ================================
// 📌 REGISTRO DEL SERVICE WORKER
// ================================
if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'production') {
  window.addEventListener('load', async () => {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((reg) => reg.unregister()));
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  });
} else if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const swUrl = `${PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        console.log('Service Worker registrado:', reg);

        reg.onupdatefound = () => {
          const newWorker = reg.installing;
          if (!newWorker) return;

          newWorker.onstatechange = () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              console.log('Nueva versión detectada');
              window.dispatchEvent(new Event('app-update-available'));
            }
          };
        };
      })
      .catch((err) => {
        console.error('Error registrando SW:', err);
      });
  });
}

// ==================================

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Performance
reportWebVitals();
